module.exports = __webpack_public_path__ + "img/800-Interactive-Email-Profile-Picture.a4fe65c7.png";